import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

/**
 * Wrapper de ruta privada. Si el usuario no está autenticado, redirige a /login.
 * Si se pasan requiredRoles y el rol del usuario no está incluido, redirige a /acceso-denegado.
 */
const PrivateRoute = ({ children, requiredRoles }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (requiredRoles && user && !requiredRoles.includes(user.rol)) {
    return <Navigate to="/acceso-denegado" replace />;
  }
  return children;
};

export default PrivateRoute;
